import { EVENTS_WEB_API_BASE } from './endpoints';
const errorCodesMap = {
    applicationError: {
        INTERNAL: false,
        INVALID_ARGUMENT: false,
        UNAUTHENTICATED_ERROR: false,
        DEADLINE_EXCEEDED: false,
        missing_required_field: false,
        MISSING_REQUEST_SITE_CONTEXT: false,
        EVENT_NOT_FOUND: false,
        EVENT_SETTINGS_NOT_FOUND: false,
        SEATING_PLAN_NOT_FOUND: false,
        ORDER_NOT_FOUND: false,
        RESERVATION_NOT_FOUND: false,
        RESERVATION_OCCUPIED: false,
        RESERVATION_EXPIRED: false,
        INVALID_REORDER_INSTRUCTION: false,
        INVALID_FORM_RESPONSE: false,
        INVALID_ITEM_REFERENCE: false,
        INVALID_CHECKOUT: false,
        TICKET_NOT_FOUND: false,
        CHARGE_ALREADY_IN_PROCESS: false,
        CHARGE_ALREADY_APPROVED: false,
        EXPIRED_JWT: false,
        GUEST_ALREADY_REGISTERED: false,
        COUPON_EXCEPTION: false,
        CHECKOUT_CLOSED: false,
        TICKET_DEFINITION_HIDDEN: false,
        TICKET_DEFINITION_NOT_FOUND: false,
        TICKETS_UNAVAILABLE: false,
    },
};
export class EventsHttpClient {
    constructor(httpClient, baseUrl = EVENTS_WEB_API_BASE, linguisticHeader, errorHandler) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.linguisticHeader = linguisticHeader;
        this.errorHandler = errorHandler;
        this.getHeaders = () => {
            return {
                headers: { 'x-wix-linguist': this.linguisticHeader },
            };
        };
        this.makeRequest = ({ url, method, data = {}, }) => {
            const { withErrorHandler } = this.errorHandler;
            return withErrorHandler(async () => this.httpClient
                .request({
                url: `${this.baseUrl}${url}`,
                method,
                data,
                ...this.getHeaders(),
            })
                .then(response => response.data), {
                // @ts-expect-error
                errorCodesMap,
            }).catch(this.logError);
        };
        this.request = (args) => {
            const { withErrorHandler } = this.errorHandler;
            return withErrorHandler(async () => this.httpClient.request(args).then(response => response.data), {
                // @ts-expect-error
                errorCodesMap,
            }).catch(this.logError);
        };
        this.logError = (e) => {
            console.error(this.errorHandler.getResolvedError(e));
            throw e;
        };
    }
    get(url) {
        return this.makeRequest({ url, method: 'GET' });
    }
    delete(url, data) {
        return this.makeRequest({ url, method: 'DELETE', data });
    }
    put(url, data) {
        return this.makeRequest({ url, method: 'PUT', data });
    }
    post(url, data) {
        return this.makeRequest({ url, method: 'POST', data });
    }
    patch(url, data) {
        return this.makeRequest({ url, method: 'PATCH', data });
    }
}
//# sourceMappingURL=http-client.js.map